export default __webpack_public_path__ + "static/media/reward.22ac027e.svg";